import {useSelector, useDispatch} from 'react-redux'
import { SET_DATA_MODAL_FORM_LIST } from '../../../../../../store/modal/const'

const useShowScheduleMeeting = () => {
  const dispatch = useDispatch()
  const reduxData = useSelector(
    (state) => state.modal.counseling.scheduleMeetingModal,
  )
  const {isOpen, onChange, task} = reduxData

  const setTaskData = (task) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'counseling.scheduleMeetingModal', // Cambiar aca
      data: {
        ...reduxData,
        task,
      },
    })
  }
  const setOpen = (open, onChange = () => {}, task) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'counseling.scheduleMeetingModal',
      data: {
        ...reduxData,
        isOpen: open,
        onChange,
        task,
      },
    })
  }

  return {
    isOpen,
    onChange,
    open: (onChange = () => {}, college = {}) => {
      setOpen(true, onChange, college)
    },
    close: () => {
      setOpen(false)
    },
    toggle: () => {
      setOpen(!isOpen)
    },
    task,
    setTaskData,
  }
}
export default useShowScheduleMeeting
